import { render, staticRenderFns } from "./GradientButton.vue?vue&type=template&id=699e88a2&scoped=true"
import script from "./GradientButton.vue?vue&type=script&lang=js"
export * from "./GradientButton.vue?vue&type=script&lang=js"
import style0 from "./GradientButton.vue?vue&type=style&index=0&id=699e88a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "699e88a2",
  null
  
)

export default component.exports